import * as Redux from 'redux';
import { DashboardActionTypes, DashboardState, DashboardEntity, CalendarEvent } from './dashboard.types';
import * as DASHBOARD_ACTION_TYPES from './dashboard.constants';
import { initialDashboardState } from './dashboard.constants';
import { ReduxAction, SimpleResponse } from '../app/app.types';
import { REVERT_TO_INITIAL_STATE, REVERT_TO_INITIAL_STATE_EXCEPT_AUTH } from '../app/app.const';
import { isUndefined } from 'util';

const dashboardReducer: Redux.Reducer<DashboardState> = 
  (dashboardState: DashboardState = initialDashboardState,
   action: ReduxAction<DashboardActionTypes, SimpleResponse<DashboardEntity>>): DashboardState => {
  switch (action.type) {
    case `${DASHBOARD_ACTION_TYPES.GET_CALENDAR_EVENTS}_FULFILLED`:
      return { ...dashboardState,
        statusCode: action.payload.statusCode,
        dashboardCalendarEvents: action.payload.body.list
      };
    case `${DASHBOARD_ACTION_TYPES.CREATE_CALENDAR_EVENT}_FULFILLED`:
      return { ...dashboardState,
        statusCode: action.payload.statusCode,
        dashboardCalendarEvents: dashboardState.dashboardCalendarEvents
          .filter((calendarEvent: CalendarEvent) => calendarEvent.id !== action.payload.body.entity.id)
          .concat(action.payload.body.entity)
      };
    case `${DASHBOARD_ACTION_TYPES.DELETE_CALENDAR_EVENT}_FULFILLED`:
      if (!isUndefined(action.meta)) {
        return { ...dashboardState,
          statusCode: action.payload.statusCode,
          dashboardCalendarEvents: dashboardState.dashboardCalendarEvents
            .filter((calendarEvent: CalendarEvent) => calendarEvent.id !== action.meta!.id)
        };  
      } else {
        return dashboardState;
      }
    case `${DASHBOARD_ACTION_TYPES.UPDATE_CALENDAR_EVENT}_FULFILLED`:
      if (!isUndefined(action.meta)) {
        return { ...dashboardState,
          statusCode: action.payload.statusCode,
          dashboardCalendarEvents: dashboardState.dashboardCalendarEvents
            .filter((calendarEvent: CalendarEvent) => calendarEvent.id !== action.meta!.id)
            .concat(action.payload.body.entity)
        };  
      } else {
        return dashboardState;
      }
    case `${DASHBOARD_ACTION_TYPES.GET_ABSENT_MEMBERS}_FULFILLED`:
      return { ...dashboardState,
        absentMembersStatus: action.payload.statusCode,
        absentMembers: action.payload.body.list
      };
    case `${DASHBOARD_ACTION_TYPES.GET_EXPIRING_MEMBERS}_FULFILLED`:
      return { ...dashboardState,
        expiringMembersStatus: action.payload.statusCode,
        expiringMembers: action.payload.body.list
      };
    case REVERT_TO_INITIAL_STATE:
      return initialDashboardState;
    case REVERT_TO_INITIAL_STATE_EXCEPT_AUTH:
      return initialDashboardState;
    default:
      return dashboardState;
  }
};

export default dashboardReducer;



// WEBPACK FOOTER //
// ./src/dashboard/dashboard.reducer.tsx